// extracted by mini-css-extract-plugin
export var blue = "_3w-g";
export var brand = "_3w-c";
export var darkGrey = "_3w-f";
export var disabled = "_3w-6";
export var disabledSubtle = "_3w-7";
export var error = "_3w-8";
export var green = "_3w-h";
export var grey = "_3w-e";
export var icon = "_3w-0";
export var inherit = "_3w-b";
export var lightGrey = "_3w-d";
export var orange = "_3w-j";
export var pink = "_3w-l";
export var primary = "_3w-1";
export var purple = "_3w-m";
export var quaternary = "_3w-4";
export var quinary = "_3w-5";
export var red = "_3w-k";
export var secondary = "_3w-2";
export var success = "_3w-a";
export var tertiary = "_3w-3";
export var warning = "_3w-9";
export var white = "_3w-n";
export var yellow = "_3w-i";